import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import scrollToComponent from 'react-scroll-to-component';

import {designerFormatName} from '../../../utils/product';

import * as productActionCreators from '../../../actions/product';
import * as userActionCreators from '../../../actions/user';
let allActionCreators = Object.assign({}, productActionCreators, userActionCreators);

import {GalleryBreadcrumbsContainer} from '../gallery/blocks/GalleryBreadcrumbs';

import {ProductSettingBannerContainer} from './blocks/ProductSettingBanner';
import {ProductDiamondBannerContainer} from './blocks/ProductDiamondBanner';
import {ProductJewelryBannerContainer} from './blocks/ProductJewelryBanner';
import ProductDetails from './blocks/ProductDetails';
import ProductDiamondCarat from './blocks/ProductDiamondCarat';
import ProductSimilarSetting from './blocks/ProductSimilarSetting';
import ProductSimilarDiamond from './blocks/ProductSimilarDiamond';
import ProductSettingPairs from './blocks/ProductSettingPairs';
import ProductDiamondsDirectDifference from './blocks/ProductDiamondsDirectDifference';
import {ProductSocialContainer} from './blocks/ProductSocial';

import RhinoLoading from '../common/RhinoLoading';

class ProductPage extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    let diamondPage = this.props.route.product_type == 'diamond';
    let settingPage = this.props.route.product_type == 'setting';
    let jewelryPage = this.props.route.product_type == 'jewelry';

		this.state = {
      isDiamondPage: diamondPage,
      isSettingPage: settingPage,
      isJewelryPage: jewelryPage,
      detailsOpen: false,

      diamondDetails: null,
      settingDetails: null,
      jewelryDetails: null,

      jewelryType: null,
    };

    if(this.state.isDiamondPage) {

      this.props.productFetchDiamondById(this.props.params.lookupKey)
      .then((respData) => {
        this.setState({ diamondDetails: respData });
      });
    } else if(this.state.isSettingPage) {

      this.props.productFetchBySku(this.props.params.lookupKey)
      .then((respData) => {
        this.setState({ settingDetails: respData.success });
      });
    } else if(this.state.isJewelryPage) {

      this.props.productFetchBySku(this.props.params.lookupKey)
      .then((respData) => {
        console.log(respData.success);
        this.setState({ 
          jewelryDetails: respData.success,
          jewelryType: respData.success && respData.success.attributes && respData.success.attributes.type && respData.success.attributes.type.includes('GTS ') ? 'mens' : null,
        });
      });
    }
	}

	componentDidMount() {
    if(this.props.user.wishlists === null) {
      this.props.userGetWishlists()
      .then((respData) => {
        this.props.userSaveWishlists(respData.wishlists);
      });
    }
  }

  getProductDetails() {

    let detail_list = [];

    if(!this.state.settingDetails) {
      return detail_list;
    }

    let styleString = '';
    if(this.state.settingDetails && this.state.settingDetails.attributes && this.state.settingDetails.attributes.style) {
      styleString = this.state.settingDetails.attributes.style;
    }

    // console.log(this.state.settingDetails);
    // console.log(this.state.settingDetails.style);

    const respArray = [
      {
        key: 'SKU',
        value: this.state.settingDetails && this.state.settingDetails.sku ? this.state.settingDetails.sku : '',
      },
      {
        key: 'Designer',
        value: this.state.settingDetails && this.state.settingDetails.vendor && this.state.settingDetails.vendor.name ? designerFormatName(this.state.settingDetails.vendor.name) : '',
      },
      {
        key: 'Type',
        value: this.state.settingDetails && this.state.settingDetails.attributes && this.state.settingDetails.attributes.settingtype ? this.state.settingDetails.attributes.settingtype : '',
      },

    ];

    if(this.state.settingDetails.ttw_dia && parseFloat(this.state.settingDetails.ttw_dia) > 0) {
      respArray.push({
        key: 'Diamond CW',
        value: this.state.settingDetails ? this.state.settingDetails.ttw_dia + ' Ct' : '',
      });
    }
    if(this.state.settingDetails.tty_gem && parseFloat(this.state.settingDetails.tty_gem) > 0) {
      respArray.push({
        key: 'Gem CW',
        value: this.state.settingDetails ? this.state.settingDetails.tty_gem + ' Ct' : '',
      });
    }
    if(this.state.settingDetails.length && parseFloat(this.state.settingDetails.length) > 0 && this.state.settingDetails.length_units) {
      respArray.push({
        key: 'Length',
        value: this.state.settingDetails ? this.state.settingDetails.length.toFixed(1) + ' ' + this.state.settingDetails.length_units.toLowerCase() : '',
      });
    }
    if(this.state.settingDetails.stone1_csw && parseFloat(this.state.settingDetails.stone1_csw) > 0) {
      respArray.push({
        key: 'CSW',
        value: this.state.settingDetails ? this.state.settingDetails.stone1_csw + ' Ct' : '',
      });
    }

    return respArray;
  }

  getDiamondDetails() {

    if(!this.state.diamondDetails) {
      return [];
    }

    if(this.state.diamondDetails.shape === 'Round') {
      return [
        {
          key: 'DIAMOND ID',
          value: this.state.diamondDetails.id,
        },
        {
          key: 'CUT',
          value: this.state.diamondDetails.cut,
        },
        {
          key: 'CARAT WEIGHT',
          value: parseFloat(this.state.diamondDetails.caratWeight).toFixed(2).toString(),
        },
        {
          key: 'POLISH',
          value: this.state.diamondDetails.polish,
        },
        {
          key: 'COLOR',
          value: this.state.diamondDetails.color,
        },
        {
          key: 'SYMMETRY',
          value: this.state.diamondDetails.symmetry,
        },
        {
          key: 'CLARITY',
          value: this.state.diamondDetails.clarity,
        },
        {
          key: 'FLUORESCENCE',
          value: this.state.diamondDetails.fluorescence,
        },
        {
          key: 'MEASUREMENTS',
          value: this.state.diamondDetails.measurement,
        },
        {
          key: 'CERTIFICATION',
          value: this.state.diamondDetails.lab,
        },
      ];
    } else {
      return [
        {
          key: 'DIAMOND ID',
          value: this.state.diamondDetails.id,
        },
        {
          key: 'CARAT WEIGHT',
          value: parseFloat(this.state.diamondDetails.caratWeight).toFixed(2).toString(),
        },
        {
          key: 'POLISH',
          value: this.state.diamondDetails.polish,
        },
        {
          key: 'COLOR',
          value: this.state.diamondDetails.color,
        },
        {
          key: 'SYMMETRY',
          value: this.state.diamondDetails.symmetry,
        },
        {
          key: 'CLARITY',
          value: this.state.diamondDetails.clarity,
        },
        {
          key: 'FLUORESCENCE',
          value: this.state.diamondDetails.fluorescence,
        },
        {
          key: 'MEASUREMENTS',
          value: this.state.diamondDetails.measurement,
        },
        {
          key: 'CERTIFICATION',
          value: this.state.diamondDetails.lab,
        },
      ];
    }
  }

  getJewelryDetails() {

    if(!this.state.jewelryDetails) {
      return [];
    }

    const respArray = [
      {
        key: 'SKU',
        value: this.state.jewelryDetails && this.state.jewelryDetails.sku ? this.state.jewelryDetails.sku : '',
      },
      {
        key: 'Designer',
        value: this.state.jewelryDetails && this.state.jewelryDetails.vendor && this.state.jewelryDetails.vendor.name ? designerFormatName(this.state.jewelryDetails.vendor.name) : '',
      },
    ];

    if(this.state.jewelryDetails.attributes && this.state.jewelryDetails.attributes.diameter) {
      respArray.push({
        key: 'Diameter',
        value: this.state.jewelryDetails.attributes.diameter.charAt(0).toUpperCase() + this.state.jewelryDetails.attributes.diameter.slice(1).toLowerCase(),
      });
    }
    if(this.state.jewelryDetails.ttw_dia && parseFloat(this.state.jewelryDetails.ttw_dia) > 0) {
      respArray.push({
        key: 'Diamond CW',
        value: this.state.jewelryDetails ? this.state.jewelryDetails.ttw_dia + ' Ct' : '',
      });
    }
    if(this.state.jewelryDetails.tty_gem && parseFloat(this.state.jewelryDetails.tty_gem) > 0) {
      respArray.push({
        key: 'Gem CW',
        value: this.state.jewelryDetails ? this.state.jewelryDetails.tty_gem + ' Ct' : '',
      });
    }
    if(this.state.jewelryDetails.length && parseFloat(this.state.jewelryDetails.length) > 0 && this.state.jewelryDetails.length_units) {
      respArray.push({
        key: 'Length',
        value: this.state.jewelryDetails ? this.state.jewelryDetails.length.toFixed(1) + ' ' + this.state.jewelryDetails.length_units.toLowerCase() : '',
      });
    }
    if(this.state.jewelryDetails.stone1_csw && parseFloat(this.state.jewelryDetails.stone1_csw) > 0) {
      respArray.push({
        key: 'CSW',
        value: this.state.jewelryDetails ? this.state.jewelryDetails.stone1_csw + ' Ct' : '',
      });
    }

    return respArray;
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  renderBannerSection() {
    if(this.state.isSettingPage) {
      return <ProductSettingBannerContainer scrollMethod={::this.scrollToDDDifference} productData={this.state.settingDetails} />;
    } else if(this.state.isDiamondPage) {
      return <ProductDiamondBannerContainer scrollMethod={::this.scrollToDDDifference} productData={this.state.diamondDetails} />;
    } else if(this.state.isJewelryPage) {
      return <ProductJewelryBannerContainer scrollMethod={::this.scrollToDDDifference} productData={this.state.jewelryDetails} />;
    } else {
      return null;
    }
  }

  renderDetailsSection() {
    if(this.state.isSettingPage) {
      return <ProductDetails details={this.getProductDetails()} diamondDetails={false} />;
    } else if(this.state.isDiamondPage) {
      return <ProductDetails details={this.getDiamondDetails()} diamondDetails={true} />;
    } else {
      return <ProductDetails details={this.getJewelryDetails()} diamondDetails={false} genericPage={true} />;
    }
  }

  renderSimilarSection() {
    if(this.state.isSettingPage) {
      // return <ProductSimilarSetting />;
      return null;
    } else if(this.state.isDiamondPage) {
      // return <ProductSimilarDiamond />;
      return null;
    } else {
      return null;
    }
  }

  scrollToDDDifference() {
    scrollToComponent(this.diffSection, {
      offset: 0, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  haveProductData() {
    if(this.state.isDiamondPage && this.state.diamondDetails !== null) {
      return true;
    } 
    if(this.state.isSettingPage && this.state.settingDetails !== null) {
      return true;
    }
    if(this.state.isJewelryPage && this.state.jewelryDetails !== null) {
      return true;
    }
    return false;
  }

	render() {
		return <div className='ProductPage'>
      <div>
        <GalleryBreadcrumbsContainer 
          hideResultCount={true} 
          productPage={true} 
          productType={this.state.jewelryType ? this.state.jewelryType : this.props.route.product_type}
          productName={this.state.isDiamondPage ? 'Diamond' : 'Setting'} />
      </div>
      {this.haveProductData() ?
        <div className='productPageWrapper'>
          <div className='bannerSectionWrapper'>{this.renderBannerSection()}</div>
          <div className='detailSectionWrapper'>{this.renderDetailsSection()}</div>
          {this.state.isDiamondPage && false ?
            <div className='caratSectionWrapper'>
              <ProductDiamondCarat shape={this.state.diamondDetails.shape} carat_weight={this.state.diamondDetails.caratWeight} />
            </div> :
            null
          }
          <div className='similarSectionWrapper'>{this.renderSimilarSection()}</div>
          {this.state.isSettingPage && false ?
            <div className='pairsSectionWrapper'>
              <ProductSettingPairs />
            </div> :
            null
          }
          <div className='differenceWrapper' ref={(div) => { this.diffSection = div; }}>
            <ProductDiamondsDirectDifference />
          </div>
          <div className='socialWrapper'>
            <ProductSocialContainer />
          </div>
        </div> :
        <div className='productPageWrapper'>
          <RhinoLoading />
        </div>
      }
      
		</div>;
	}
}
export default ProductPage;

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export const ProductPageContainer = connect(
  mapStateToProps,
  allActionCreators
)(ProductPage);


// WEBPACK FOOTER //
// ./src/components/views/product-page/ProductPage.jsx